import { Link } from "react-router-dom";
import { Badges, P, SVG } from "../../../AbstractElements";
import { Href } from "../../../utils/Constant";
// import { Rating } from "react-simple-star-rating";
// import { dynamicImage } from "../../../Service";
import { TableColumn } from "react-data-table-component";
import { FoodTableDataColumnType, FoodTableOffer } from "../../../Types/Application/Ecommerce/Ecommerce";
import Swal from "sweetalert2";
import api from "../../../utils/api";

export const FoodListTableData = [
    {
        foodMasterId: 1,
        images: "image1.jpg",
        sellingprice: 100,
        foodprice: 80,
        foodCategoryId: 10,
        categoryName: "Snacks",
    },
    {
        foodMasterId: 2,
        images: "image2.jpg",
        sellingprice: 150,
        foodprice: 120,
        foodCategoryId: 20,
        categoryName: "Beverages",
    },
];

// const RfidCardListTableAction = () => {
//   return (
//     <div className="product-action">
//       <Link to={Href}>
//         <SVG iconId="edit-content" style={{ fill: 'blue' }} />
//       </Link>
//       <SVG iconId="trash1" style={{ fill: 'red' }}/>
//     </div>
//   );
// };

const handleDelete = async (id: number) => {
  // Your delete logic here (API call, state update, etc.)
  // console.log("Deleting ID:", id);
 try {
        await api.delete(`/api/FoodMaster/DeleteFoodMasterById?FoodMastrId=${id}`);
       Swal.fire('Deleted!', 'Food has been deleted.', 'success');
      } catch (error) {
        Swal.fire('Error!', 'Failed to delete the food.', 'error');
        console.error("Delete error:", error);
      }
};

interface ProductListTableActionProps {
  foodMasterId: any;
  onDelete: (id: number) => void;
}

export const FoodTableAction: React.FC<ProductListTableActionProps> = ({ foodMasterId, onDelete }) => {
  const editUrl = `/rfid_card/edit/${foodMasterId}`;

  const handleDeleteClick = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this food!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        onDelete(foodMasterId);
      }
    });
  };

  return (
    <div className="product-action d-flex gap-2">
      {/* <Link to={editUrl}>
        <SVG iconId="edit-content" style={{ fill: 'blue' }} />
      </Link> */}
      <button className="btn btn-sm" onClick={handleDeleteClick}>
        <SVG iconId="trash1" style={{ fill: 'red' }} />
      </button>
    </div>
  );
};

export const FoodTableOfferComponent: React.FC<FoodTableOffer> = ({ title }) => {
  return (
    <div className="product-names my-2">
      <P>{title}</P>
    </div>
  );
};

export const FoodTableStatus :React.FC<FoodTableOffer> = ({ title }) => {
  return (
    <Badges color="" className={`badge-light-${title === "Active" ? "secondary" : "primary" }`}>{title}</Badges>
  );
};

export  const FoodListTableDataColumn: TableColumn<FoodTableDataColumnType>[] = [
      {
        name: "Food Name",
        cell: (row) => <FoodTableOfferComponent title={String(row.foodname)}/>,
        sortable: true,
        grow: 2,
      },
    {
        name: "Food Category",
        cell: (row) => <FoodTableOfferComponent title={String(row.categoryName)}/>,
        sortable: true,
        grow: 2,
    },
    {
        name: "Selling Price",
        cell: (row) => <P>{row.sellingprice}</P>,
    },
    {
        name: "Food Price",
        cell: (row) => <P>{row.foodprice}</P>,
    },
    {
        name: "Image",
        cell: (row) => (
          <div className="product-image">
            <img src={row.images} alt={row.foodname} className="img-fluid" />
          </div>
        ),
        grow: 1,
    },
      {
        name: "Action",
        cell: (row) => <FoodTableAction foodMasterId={row.foodMasterId} onDelete={handleDelete} />,
      },
    ];

  export const filtersData = [
    {
      name: "Choose food category",
      options: ["Veg", "Fruits", "Vegetables", "Snacks", "Beverages"],
    },
    {
      name: "Status",
      options: ["Active", "Inactive"],
    },
  ];